import React from 'react';
import { Outlet } from 'react-router-dom';
import { JobAdPreferencesProvider } from 'contexts/JobAdPreferencesContext';
import { FiltersProvider } from 'contexts/FiltersContext';

// This layout wraps any child routes with the FiltersProvider.
const FilterLayout = () => {
  return (
    <FiltersProvider>
      <JobAdPreferencesProvider>
        <Outlet />
      </JobAdPreferencesProvider>
    </FiltersProvider>
  );
};

export default FilterLayout;